module.exports = __webpack_public_path__ + "img/drag.3bf52041.svg";